/*!
 * based on https://github.com/tnwinc/htmldiff.js
 * Licensed under the MIT License.
 */
// Generated by CoffeeScript 1.9.2
// +RF 2015-09-23: extended to support unicode word characters (replaces "\w" in RegExp)
// +RF 2020-12-10: converted to ES module


var Match, calculate_operations, consecutive_where, create_index, find_match, find_matching_blocks, html_to_tokens, is_end_of_tag, is_start_of_tag, is_tag, is_whitespace, isnt_tag, op_map, recursively_find_matching_blocks, render_operations, wrap;

is_end_of_tag = function(c) {
	return c === '>';
};

is_start_of_tag = function(c) {
	return c === '<';
};

is_whitespace = function(c) {
	return /^\s+$/.test(c);
};

is_tag = function(token) {
	return /^\s*<[^>]+>\s*$/.test(token);
};

isnt_tag = function(token) {
	return !is_tag(token);
};

Match = (function() {
	function Match(start_in_before1, start_in_after1, length1) {
		this.start_in_before = start_in_before1;
		this.start_in_after = start_in_after1;
		this.length = length1;
		this.end_in_before = (this.start_in_before + this.length) - 1;
		this.end_in_after = (this.start_in_after + this.length) - 1;
	}

	return Match;

})();

html_to_tokens = function(html) {
	var c, current_word, i, len, mode, words;
	mode = 'char';
	current_word = '';
	words = [];
	for (i = 0, len = html.length; i < len; i++) {
		c = html[i];
		switch (mode) {
			case 'tag':
				if (is_end_of_tag(c)) {
					current_word += '>';
					words.push(current_word);
					current_word = '';
					if (is_whitespace(c)) {
						mode = 'whitespace';
					} else {
						mode = 'char';
					}
				} else {
					current_word += c;
				}
				break;
			case 'char':
				if (is_start_of_tag(c)) {
					if (current_word) {
						words.push(current_word);
					}
					current_word = '<';
					mode = 'tag';
				} else if (/\s/.test(c)) {
					if (current_word) {
						words.push(current_word);
					}
					current_word = c;
					mode = 'whitespace';
				} else if (/(([0-9A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0345\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05B0-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05F0-\u05F2\u0610-\u061A\u0620-\u0657\u0659-\u0669\u066E-\u06D3\u06D5-\u06DC\u06E1-\u06E8\u06ED-\u06FC\u06FF\u0710-\u073F\u074D-\u07B1\u07C0-\u07EA\u07F4\u07F5\u07FA\u0800-\u0817\u081A-\u082C\u0840-\u0858\u08A0-\u08B4\u08E3-\u08E9\u08F0-\u093B\u093D-\u094C\u094E-\u0950\u0955-\u0963\u0966-\u096F\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD-\u09C4\u09C7\u09C8\u09CB\u09CC\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09F1\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3E-\u0A42\u0A47\u0A48\u0A4B\u0A4C\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD-\u0AC5\u0AC7-\u0AC9\u0ACB\u0ACC\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AEF\u0AF9\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D-\u0B44\u0B47\u0B48\u0B4B\u0B4C\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B6F\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCC\u0BD0\u0BD7\u0BE6-\u0BEF\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4C\u0C55\u0C56\u0C58-\u0C5A\u0C60-\u0C63\u0C66-\u0C6F\u0C81-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCC\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1\u0CF2\u0D01-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D-\u0D44\u0D46-\u0D48\u0D4A-\u0D4C\u0D4E\u0D57\u0D5F-\u0D63\u0D66-\u0D6F\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E46\u0E4D\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0ECD\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F20-\u0F29\u0F40-\u0F47\u0F49-\u0F6C\u0F71-\u0F81\u0F88-\u0F97\u0F99-\u0FBC\u1000-\u1036\u1038\u103B-\u1049\u1050-\u1062\u1065-\u1068\u106E-\u1086\u108E\u1090-\u1099\u109C\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135F\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1713\u1720-\u1733\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17B3\u17B6-\u17C8\u17D7\u17DC\u17E0-\u17E9\u1810-\u1819\u1820-\u1877\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u1938\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19D9\u1A00-\u1A1B\u1A20-\u1A5E\u1A61-\u1A74\u1A80-\u1A89\u1A90-\u1A99\u1AA7\u1B00-\u1B33\u1B35-\u1B43\u1B45-\u1B4B\u1B50-\u1B59\u1B80-\u1BA9\u1BAC-\u1BE5\u1BE7-\u1BF1\u1C00-\u1C35\u1C40-\u1C49\u1C4D-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1D00-\u1DBF\u1DE7-\u1DF4\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200C\u200D\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u24B6-\u24E9\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u2E2F\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66E\uA674-\uA67B\uA67F-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA827\uA840-\uA873\uA880-\uA8C3\uA8D0-\uA8D9\uA8F2-\uA8F7\uA8FB\uA8FD\uA900-\uA92A\uA930-\uA952\uA960-\uA97C\uA980-\uA9B2\uA9B4-\uA9BF\uA9CF-\uA9D9\uA9E0-\uA9E4\uA9E6-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA60-\uAA76\uAA7A\uAA7E-\uAABE\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF5\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABEA\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF30-\uDF4A\uDF50-\uDF7A\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCA0-\uDCA9\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00-\uDE03\uDE05\uDE06\uDE0C-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC00-\uDC45\uDC66-\uDC6F\uDC82-\uDCB8\uDCD0-\uDCE8\uDCF0-\uDCF9\uDD00-\uDD32\uDD36-\uDD3F\uDD50-\uDD72\uDD76\uDD80-\uDDBF\uDDC1-\uDDC4\uDDD0-\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE34\uDE37\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEE8\uDEF0-\uDEF9\uDF00-\uDF03\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D-\uDF44\uDF47\uDF48\uDF4B\uDF4C\uDF50\uDF57\uDF5D-\uDF63]|\uD805[\uDC80-\uDCC1\uDCC4\uDCC5\uDCC7\uDCD0-\uDCD9\uDD80-\uDDB5\uDDB8-\uDDBE\uDDD8-\uDDDD\uDE00-\uDE3E\uDE40\uDE44\uDE50-\uDE59\uDE80-\uDEB5\uDEC0-\uDEC9\uDF00-\uDF19\uDF1D-\uDF2A\uDF30-\uDF39]|\uD806[\uDCA0-\uDCE9\uDCFF\uDEC0-\uDEF8]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE60-\uDE69\uDED0-\uDEED\uDF00-\uDF36\uDF40-\uDF43\uDF50-\uDF59\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50-\uDF7E\uDF93-\uDF9F]|\uD82C[\uDC00\uDC01]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99\uDC9E]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB\uDFCE-\uDFFF]|\uD83A[\uDC00-\uDCC4]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD83C[\uDD30-\uDD49\uDD50-\uDD69\uDD70-\uDD89]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1]|\uD87E[\uDC00-\uDE1D])|[\#@])+/i.test(c)) {
					// == unicode variation of "/[\w\#@]+/i"
					current_word += c;
				} else {
					if (current_word) {
						words.push(current_word);
					}
					current_word = c;
				}
				break;
			case 'whitespace':
				if (is_start_of_tag(c)) {
					if (current_word) {
						words.push(current_word);
					}
					current_word = '<';
					mode = 'tag';
				} else if (is_whitespace(c)) {
					current_word += c;
				} else {
					if (current_word) {
						words.push(current_word);
					}
					current_word = c;
					mode = 'char';
				}
				break;
			default:
				throw new Error("Unknown mode " + mode);
		}
	}
	if (current_word) {
		words.push(current_word);
	}
	return words;
};

find_match = function(before_tokens, after_tokens, index_of_before_locations_in_after_tokens, start_in_before, end_in_before, start_in_after, end_in_after) {
	var best_match_in_after, best_match_in_before, best_match_length, i, index_in_after, index_in_before, j, len, locations_in_after, looking_for, match, match_length_at, new_match_length, new_match_length_at, ref, ref1;
	best_match_in_before = start_in_before;
	best_match_in_after = start_in_after;
	best_match_length = 0;
	match_length_at = {};
	for (index_in_before = i = ref = start_in_before, ref1 = end_in_before; ref <= ref1 ? i < ref1 : i > ref1; index_in_before = ref <= ref1 ? ++i : --i) {
		new_match_length_at = {};
		looking_for = before_tokens[index_in_before];
		locations_in_after = index_of_before_locations_in_after_tokens[looking_for];
		for (j = 0, len = locations_in_after.length; j < len; j++) {
			index_in_after = locations_in_after[j];
			if (index_in_after < start_in_after) {
				continue;
			}
			if (index_in_after >= end_in_after) {
				break;
			}
			if (match_length_at[index_in_after - 1] == null) {
				match_length_at[index_in_after - 1] = 0;
			}
			new_match_length = match_length_at[index_in_after - 1] + 1;
			new_match_length_at[index_in_after] = new_match_length;
			if (new_match_length > best_match_length) {
				best_match_in_before = index_in_before - new_match_length + 1;
				best_match_in_after = index_in_after - new_match_length + 1;
				best_match_length = new_match_length;
			}
		}
		match_length_at = new_match_length_at;
	}
	if (best_match_length !== 0) {
		match = new Match(best_match_in_before, best_match_in_after, best_match_length);
	}
	return match;
};

recursively_find_matching_blocks = function(before_tokens, after_tokens, index_of_before_locations_in_after_tokens, start_in_before, end_in_before, start_in_after, end_in_after, matching_blocks) {
	var match;
	match = find_match(before_tokens, after_tokens, index_of_before_locations_in_after_tokens, start_in_before, end_in_before, start_in_after, end_in_after);
	if (match != null) {
		if (start_in_before < match.start_in_before && start_in_after < match.start_in_after) {
			recursively_find_matching_blocks(before_tokens, after_tokens, index_of_before_locations_in_after_tokens, start_in_before, match.start_in_before, start_in_after, match.start_in_after, matching_blocks);
		}
		matching_blocks.push(match);
		if (match.end_in_before <= end_in_before && match.end_in_after <= end_in_after) {
			recursively_find_matching_blocks(before_tokens, after_tokens, index_of_before_locations_in_after_tokens, match.end_in_before + 1, end_in_before, match.end_in_after + 1, end_in_after, matching_blocks);
		}
	}
	return matching_blocks;
};

create_index = function(p) {
	var i, idx, index, len, ref, token;
	if (p.find_these == null) {
		throw new Error('params must have find_these key');
	}
	if (p.in_these == null) {
		throw new Error('params must have in_these key');
	}
	index = {};
	ref = p.find_these;
	for (i = 0, len = ref.length; i < len; i++) {
		token = ref[i];
		index[token] = [];
		idx = p.in_these.indexOf(token);
		while (idx !== -1) {
			index[token].push(idx);
			idx = p.in_these.indexOf(token, idx + 1);
		}
	}
	return index;
};

find_matching_blocks = function(before_tokens, after_tokens) {
	var index_of_before_locations_in_after_tokens, matching_blocks;
	matching_blocks = [];
	index_of_before_locations_in_after_tokens = create_index({
		find_these: before_tokens,
		in_these: after_tokens
	});
	return recursively_find_matching_blocks(before_tokens, after_tokens, index_of_before_locations_in_after_tokens, 0, before_tokens.length, 0, after_tokens.length, matching_blocks);
};

calculate_operations = function(before_tokens, after_tokens) {
	var action_map, action_up_to_match_positions, i, index, is_single_whitespace, j, last_op, len, len1, match, match_starts_at_current_position_in_after, match_starts_at_current_position_in_before, matches, op, operations, position_in_after, position_in_before, post_processed;
	if (before_tokens == null) {
		throw new Error('before_tokens?');
	}
	if (after_tokens == null) {
		throw new Error('after_tokens?');
	}
	position_in_before = position_in_after = 0;
	operations = [];
	action_map = {
		'false,false': 'replace',
		'true,false': 'insert',
		'false,true': 'delete',
		'true,true': 'none'
	};
	matches = find_matching_blocks(before_tokens, after_tokens);
	matches.push(new Match(before_tokens.length, after_tokens.length, 0));
	for (index = i = 0, len = matches.length; i < len; index = ++i) {
		match = matches[index];
		match_starts_at_current_position_in_before = position_in_before === match.start_in_before;
		match_starts_at_current_position_in_after = position_in_after === match.start_in_after;
		action_up_to_match_positions = action_map[[match_starts_at_current_position_in_before, match_starts_at_current_position_in_after].toString()];
		if (action_up_to_match_positions !== 'none') {
			operations.push({
				action: action_up_to_match_positions,
				start_in_before: position_in_before,
				end_in_before: (action_up_to_match_positions !== 'insert' ? match.start_in_before - 1 : void 0),
				start_in_after: position_in_after,
				end_in_after: (action_up_to_match_positions !== 'delete' ? match.start_in_after - 1 : void 0)
			});
		}
		if (match.length !== 0) {
			operations.push({
				action: 'equal',
				start_in_before: match.start_in_before,
				end_in_before: match.end_in_before,
				start_in_after: match.start_in_after,
				end_in_after: match.end_in_after
			});
		}
		position_in_before = match.end_in_before + 1;
		position_in_after = match.end_in_after + 1;
	}
	post_processed = [];
	last_op = {
		action: 'none'
	};
	is_single_whitespace = function(op) {
		if (op.action !== 'equal') {
			return false;
		}
		if (op.end_in_before - op.start_in_before !== 0) {
			return false;
		}
		return /^\s$/.test(before_tokens.slice(op.start_in_before, +op.end_in_before + 1 || 9e9));
	};
	for (j = 0, len1 = operations.length; j < len1; j++) {
		op = operations[j];
		if (((is_single_whitespace(op)) && last_op.action === 'replace') || (op.action === 'replace' && last_op.action === 'replace')) {
			last_op.end_in_before = op.end_in_before;
			last_op.end_in_after = op.end_in_after;
		} else {
			post_processed.push(op);
			last_op = op;
		}
	}
	return post_processed;
};

consecutive_where = function(start, content, predicate) {
	var answer, i, index, last_matching_index, len, token;
	content = content.slice(start, +content.length + 1 || 9e9);
	last_matching_index = void 0;
	for (index = i = 0, len = content.length; i < len; index = ++i) {
		token = content[index];
		answer = predicate(token);
		if (answer === true) {
			last_matching_index = index;
		}
		if (answer === false) {
			break;
		}
	}
	if (last_matching_index != null) {
		return content.slice(0, +last_matching_index + 1 || 9e9);
	}
	return [];
};

wrap = function(tag, content) {
	var length, non_tags, position, rendering, tags;
	rendering = '';
	position = 0;
	length = content.length;
	while (true) {
		if (position >= length) {
			break;
		}
		non_tags = consecutive_where(position, content, isnt_tag);
		position += non_tags.length;
		if (non_tags.length !== 0) {
			rendering += "<" + tag + ">" + (non_tags.join('')) + "</" + tag + ">";
		}
		if (position >= length) {
			break;
		}
		tags = consecutive_where(position, content, is_tag);
		position += tags.length;
		rendering += tags.join('');
	}
	return rendering;
};

op_map = {
	equal: function(op, before_tokens, after_tokens) {
		return before_tokens.slice(op.start_in_before, +op.end_in_before + 1 || 9e9).join('');
	},
	insert: function(op, before_tokens, after_tokens) {
		var val;
		val = after_tokens.slice(op.start_in_after, +op.end_in_after + 1 || 9e9);
		return wrap('ins', val);
	},
	"delete": function(op, before_tokens, after_tokens) {
		var val;
		val = before_tokens.slice(op.start_in_before, +op.end_in_before + 1 || 9e9);
		return wrap('del', val);
	}
};

op_map.replace = function(op, before_tokens, after_tokens) {
	return (op_map["delete"](op, before_tokens, after_tokens)) + (op_map.insert(op, before_tokens, after_tokens));
};

render_operations = function(before_tokens, after_tokens, operations) {
	var i, len, op, rendering;
	rendering = '';
	for (i = 0, len = operations.length; i < len; i++) {
		op = operations[i];
		rendering += op_map[op.action](op, before_tokens, after_tokens);
	}
	return rendering;
};

export let diff = function(before, after) {
	var ops;
	if (before === after) {
		return before;
	}
	before = html_to_tokens(before);
	after = html_to_tokens(after);
	ops = calculate_operations(before, after);
	return render_operations(before, after, ops);
};

diff.html_to_tokens = html_to_tokens;

diff.find_matching_blocks = find_matching_blocks;

find_matching_blocks.find_match = find_match;

find_matching_blocks.create_index = create_index;

diff.calculate_operations = calculate_operations;

diff.render_operations = render_operations;

